<template>
  <div class="bg_white top_wid">
    <!-- 顶部  -->
    <div
      class="bg_home flex flex_between top_wid fixed_lt"
      style="height: 56px"
    >
      <div class="text_center ml_25 pol_abs_l">
        <div @click="showmenu = !showmenu" class="flex mr_40">
          <div style="width: 125px; border-radius: 4px">
            <img
              style="width: 125px; padding: 5px 0"
              src="../assets/Battertimg/PC/logo1000.png"
              alt=""
            />
          </div>
          <!-- <span class="text_center ml_10 color_white font_24">Smart User</span> -->
        </div>
        <!-- <div class="flex" style="margin-left: 14px; height: 100%">
          <ul class="outline text_left">
            <li class="color_white mt_5 font_12">
              <span class="text_bold">Current User: </span>{{ superior_name }}
              <span class="text_bold">Role:</span> {{ rolename }}
            </li>
            <li class="color_white mt_5 font_12">Logged in since {{ date }}</li>
          </ul>
        </div> -->
      </div>
      <!-- <div class="flex flex_center mr_20 text_left">
        <div class="text_center">
          <ul>
            <li class="font_14">
              <button id="refresh" class="btn color_icon_btn flex flex_around">
                <img class="icon_top" title="resert" src="" alt="resert" />
                <span @click="goresert" class="ml_5 text_bold"
                  >Resert Password</span
                >
              </button>
            </li>
          </ul>
        </div>
        <div class="text_center">
          <ul>
            <li class="mr_15 font_14">
              <button
                id="refresh"
                @click="logout"
                class="btn color_icon_btn flex flex_around"
              >
                <img class="icon_top" title="logout" src="" alt="logout" />
                <div>
                  <span class="ml_5 text_bold">Logout</span>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <div>
      <div style="padding-top: 56px" class="flex flex_left min_h bg_white">
        <!-- 左侧导航 -->
        <div
          class="aside"
          v-if="showmenu"
          style="
            margin-top: 6px;
            background-color: #1484d6;
            transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          "
        >
          <el-menu
            :default-active="$store.state.active"
            class="el-menu-vertical-dm"
            @select="changeactive"
            :unique-opened="true"
            text-color="#fff"
            background-color=" #1484d6"
            active-text-color="#00FFCC"
          >
            <!-- Product -->
            <router-link to="/admin/Product">
              <el-menu-item class="flex flex_around" index="0">
                <div
                  class="flex flex_left"
                  style="
                    background-color: rgb(16, 106, 171, 0.6);
                    width: 100%;
                    height: 75%;
                    text-align: left;
                    border-radius: 5px;
                  "
                >
                  <div class="flex flex_around" style="padding: 0 15px">
                    <div>
                      <i class="el-icon-s-data"></i>
                      <span slot="title" style="margin-right: 10px"
                        >Product</span
                      >
                    </div>
                  </div>
                </div>
              </el-menu-item>
            </router-link>
            <!-- Gallery (Case) -->
            <router-link to="/admin/Gallery">
              <el-menu-item class="flex flex_around" index="1">
                <div
                  class="flex flex_left"
                  style="
                    background-color: rgb(16, 106, 171, 0.6);
                    width: 100%;
                    height: 75%;
                    text-align: left;
                    border-radius: 5px;
                  "
                >
                  <div class="flex flex_around" style="padding: 0 15px">
                    <div>
                      <i class="el-icon-s-data"></i>
                      <span slot="title" style="margin-right: 10px"
                        >Gallery</span
                      >
                    </div>
                  </div>
                </div>
              </el-menu-item>
            </router-link>
            <!--Enquiries (Orders) -->
            <router-link to="/admin/Enquiries">
              <el-menu-item class="flex flex_around" index="2">
                <div
                  class="flex flex_left"
                  style="
                    background-color: rgb(16, 106, 171, 0.6);
                    width: 100%;
                    height: 75%;
                    text-align: left;
                    border-radius: 5px;
                  "
                >
                  <div class="flex flex_around" style="padding: 0 15px">
                    <div>
                      <i class="el-icon-s-data"></i>
                      <span slot="title" style="margin-right: 10px"
                        >Enquiries</span
                      >
                    </div>
                  </div>
                </div>
              </el-menu-item>
            </router-link>
            <!-- Enquiry Type(Intention) -->
            <router-link to="/admin/Enquiry">
              <el-menu-item class="flex flex_around" index="3">
                <div
                  class="flex flex_left"
                  style="
                    background-color: rgb(16, 106, 171, 0.6);
                    width: 100%;
                    height: 75%;
                    text-align: left;
                    border-radius: 5px;
                  "
                >
                  <div class="flex flex_around" style="padding: 0 15px">
                    <div>
                      <i class="el-icon-s-data"></i>
                      <span slot="title" style="margin-right: 10px"
                        >Enquiry Type</span
                      >
                    </div>
                  </div>
                </div>
              </el-menu-item>
            </router-link>
            <!-- LoginUser -->
            <router-link to="/admin/LoginUser">
              <el-menu-item class="flex flex_around" index="4">
                <div
                  class="flex flex_left"
                  style="
                    background-color: rgb(16, 106, 171, 0.6);
                    width: 100%;
                    height: 75%;
                    text-align: left;
                    border-radius: 5px;
                  "
                >
                  <div class="flex flex_around" style="padding: 0 15px">
                    <div>
                      <i class="el-icon-s-data"></i>
                      <span slot="title" style="margin-right: 10px">Users</span>
                    </div>
                  </div>
                </div>
              </el-menu-item>
            </router-link>
            <el-menu-item class="flex flex_around">
              <div
                class="flex flex_left"
                style="
                  background-color: rgb(16, 106, 171, 0.6);
                  width: 100%;
                  height: 75%;
                  text-align: left;
                  border-radius: 5px;
                "
              >
                <div
                  @click="logout()"
                  class="flex flex_around"
                  style="padding: 0 15px"
                >
                  <div>
                    <i class="el-icon-s-data"></i>
                    <span slot="title" style="margin-right: 10px">Logout</span>
                  </div>
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
        <!-- 内容 class="pos_rel" -->

        <div
          id="box1"
          style="min-width: calc(100vw - 60px)"
          :style="{
            marginLeft: showmenu ? '170px' : '0',
            minWidth: showmenu ? 'calc(100vw - 230px)' : 'calc(100vw - 60px)',
          }"
        >
          <div class="bg_white">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      showmenu: true,
      date: "",
      offsetwidth: document.documentElement.clientWidth,
      timer: false,
      // showmodel: true,
      RoleID: "",
      EmpID: "",
      defaultActive: "",
      rolename: sessionStorage.getItem("Role_Name"),
      superior_name: sessionStorage.getItem("name"),
    };
  },
  created() {
    this.$store.state.active
      ? (this.defaultActive = this.$store.state.active)
      : (this.defaultActive = "0");
    this.date = window.sessionStorage.getItem("date");
    this.RoleID = parseInt(window.sessionStorage.getItem("Role_ID"));
    this.EmpID = parseInt(window.sessionStorage.getItem("Employee_ID"));
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", () => {
      window.offsetwidth = document.documentElement.clientWidth;
      that.offsetwidth = window.offsetwidth;
    });
  },
  watch: {
    // 如果 `offset ` 发生改变，这个函数就会运行
    offsetwidth: function (val) {
      if (!this.timer) {
        this.offsetwidth = val;
        this.showmenu = this.offsetwidth > 700;
        // this.changeheight(val);
        this.timer = true;
        let that = this;
        let timeout = setTimeout(function () {
          // clearTimeout(timeout);/
          //频繁触发 resize 函数，会导致页面很卡
          that.timer = false;
        }, 100);
      }
    },
  },
  methods: {
    changeactive(e) {
      // console.log(e);
      window.sessionStorage.setItem("active", e);
      this.$store.commit("setActive", window.sessionStorage.getItem("active"));
      this.defaultActive = this.$store.state.active;
    },
    goresert() {
      this.$router.push("/resert");
    },

    reload() {
      location.reload();
    },

    logout() {
      this.$confirm("Are you sure to log out?", "TIP", {
        confirmButtonText: "confirm",
        cancelButtonText: "cancel",
      })
        .then(() => {
          this.$router.push("/admin/Login");
          window.sessionStorage.clear();
          window.localStorage.clear();
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
@import url("../assets/sass/global.css");
.aside {
  position: fixed;
  z-index: 1000;
  top: 50px;
}
</style>
